var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#347af0;stroke:#707070;opacity:0;}.b{fill:#438afb;}.c{stroke:none;}.d{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-888 -188)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(888 188)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(892 192)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M14.716,10.5a9.084,9.084,0,0,1-2.853-.454,1.3,1.3,0,0,0-1.268.267L8.8,11.673A9.942,9.942,0,0,1,4.326,7.2L5.644,5.452a1.293,1.293,0,0,0,.318-1.31,9.1,9.1,0,0,1-.456-2.858A1.285,1.285,0,0,0,4.222,0H1.284A1.285,1.285,0,0,0,0,1.284,14.733,14.733,0,0,0,14.716,16,1.285,1.285,0,0,0,16,14.716v-2.93A1.285,1.285,0,0,0,14.716,10.5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.5f8c2ccf0297d44c56ea76af089651ae.svg";
export { ForwardRef as ReactComponent };